module.exports = __webpack_public_path__ + "img/help-section-image02.76969709.png";